import { styled } from "@mui/material";
import Banner from "assets/Image/ImgHome/Banner1.jpg";


const ContainerBG = styled("div")(
    {
        backgroundImage: `url(${Banner})`,
        backgroundPositionX: "center",
        backgroundPosittionY: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: 'relative',
        backgroundAttachment: "fixed",
        height: "100vh"
    }
);

type Props = {
    children?: React.ReactNode;
};

const LayoutDefault: React.FC<Props> = ({ children }) => {

    return (
        <ContainerBG>
            {children}
        </ContainerBG>
    );
};

export default LayoutDefault;
